Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.MapLayerActions = Greenmile.Toolbar.MapLayerActions || {};

class DepartureLayer extends Greenmile.Toolbar.MapLayerActions.Base {
  constructor() {
    super();
    let instanceToDataClass = null;
    this.setInstanceToClassData = (instanceOfClass) => {
      instanceToDataClass = instanceOfClass;
    };
    this.afterClickOnCheckBox = (element) => {
      if (instanceToDataClass) {
        if (element.target.checked) {
          instanceToDataClass.getDeparturesAndDrawOnMap();
        } else {
          instanceToDataClass.removeDeparturesFromMap();
        }
      }
      this.fireEvent('afterClickOnCheckBox');
    };
  }
  LAYER_NAME = 'departure';
  RESOURCE_LAYER = 'ToolBar.Layers.Departure';
}

Greenmile.Toolbar.MapLayerActions.Departure = DepartureLayer;
